(function () {
  const scrollVisElements = document.querySelectorAll(
    ".scroll-vis, .scroll-vis-25, .scroll-vis-50",
  );

  if (scrollVisElements.length) {
    const observerCache = new Map();

    function getObserver(offset = 0) {
      if (observerCache.has(offset)) {
        return observerCache.get(offset);
      }

      const observer = new IntersectionObserver(
        (entries) => {
          for (const entry of entries) {
            entry.target.classList.toggle("is-vis", entry.isIntersecting);
          }
        },
        {
          root: null,

          // Shrinks the bottom of the viewport upward
          rootMargin: `0px 0px -${offset}% 0px`,

          threshold: 0,
        },
      );

      observerCache.set(offset, observer);

      return observer;
    }

    scrollVisElements.forEach((el) => {
      let offset = 0;

      if (el.classList.contains("scroll-vis-25")) {
        offset = 25;
      } else if (el.classList.contains("scroll-vis-50")) {
        offset = 50;
      }

      getObserver(offset).observe(el);
    });
  }
})();
